import { useCallback } from 'react';
import { findPreferredStatus } from '../../FlowchartView/utils/statusManagement';

/**
 * Hook for TodoListView action handlers
 * Handles: completion toggle, drill-in navigation
 */
export function useTodoListActions({
  allTasksFlat,
  statuses,
  onStatusChange,
  onOpenNestedSprint,
}) {
  // Handle task completion toggle
  // Uses category-based checking: any "completed" category = checked
  const handleToggleComplete = useCallback((taskId, isSubtask, parentTaskId) => {
    if (isSubtask && parentTaskId) {
      // Subtask toggle - not implemented yet
      return;
    }
    
    const task = allTasksFlat.find(t => t.id === taskId);
    
    if (!task) {
      console.warn('[TodoListView] Task not found for toggle:', taskId);
      return;
    }
    
    const currentStatus = statuses.find(s => s.id === task.status);
    const isCurrentlyCompleted = currentStatus?.category === 'completed';
    
    if (isCurrentlyCompleted) {
      const todoStatus = findPreferredStatus(statuses, 'not_started');
      onStatusChange?.(taskId, todoStatus?.id);
    } else {
      const doneStatus = findPreferredStatus(statuses, 'completed');
      onStatusChange?.(taskId, doneStatus?.id);
    }
  }, [allTasksFlat, statuses, onStatusChange]);

  // Handle clicking on a nested campaign item to drill in
  const handleDrillIn = useCallback((nestedSprint) => {
    if (nestedSprint) {
      onOpenNestedSprint?.(nestedSprint);
    }
  }, [onOpenNestedSprint]);

  return {
    handleToggleComplete,
    handleDrillIn,
  };
}
